module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.render) ? _c('div', {
    staticClass: "main-page-box"
  }, [_c('div', {
    staticClass: "back-box",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  }), _vm._v("\n    BACK to List\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "bread-box d-flex align-center"
  }, [_c('span', {
    staticClass: "span-action",
    on: {
      "click": _vm.backToSearch
    }
  }, [_vm._v(_vm._s(_vm.locationLabel))]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right fa-fw"
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Activities")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.view.ProductName))])]), _vm._v(" "), _c('div', {
    staticClass: "page-title-box"
  }, [_vm._v(_vm._s(_vm.view.ProductName))]), _vm._v(" "), _c('div', {
    staticClass: "main-box d-flex align-start"
  }, [_c('div', {
    staticClass: "desc-box"
  }, [_c('div', {
    staticClass: "view-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.view.product_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "view-desc p-overwrite",
    domProps: {
      "innerHTML": _vm._s(_vm.view.Description)
    }
  }), _vm._v(" "), (_vm.view.MaxTravellerCount) ? _c('div', {
    staticClass: "max-travel-box page-box"
  }, [_c('div', {
    staticClass: "page-label"
  }, [_vm._v("Max Traveler Count "), _c('b', [_vm._v(_vm._s(_vm.view.MaxTravellerCount))])])]) : _vm._e(), _vm._v(" "), (_vm.view.VoucherOption_List && _vm.view.VoucherOption_List.comments.length) ? _c('div', {
    staticClass: "voucher-box page-box"
  }, [_c('div', {
    staticClass: "page-label"
  }, [_vm._v("Voucher Information")]), _vm._v(" "), _c('div', {
    staticClass: "voucher-desc"
  }, [_vm._v(_vm._s(_vm.view.VoucherOption_List.comments[0].description))])]) : _vm._e(), _vm._v(" "), (_vm.view.DepartureTime || _vm.view.DeparturePoint || _vm.view.DepartureTimeComments) ? _c('div', {
    staticClass: "departure-box page-box"
  }, [_c('div', {
    staticClass: "page-label"
  }, [_vm._v("Departure Information")]), _vm._v(" "), (_vm.view.DepartureTime) ? _c('div', {
    staticClass: "dep-time"
  }, [_c('i', {
    staticClass: "fas fa-clock fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.timeFormat(_vm.view.DepartureTime)))])]) : _vm._e(), _vm._v(" "), (_vm.view.DeparturePoint) ? _c('div', {
    staticClass: "dep-loc"
  }, [_c('i', {
    staticClass: "fas fa-map-marker fa-fw"
  }), _vm._v("\n          " + _vm._s(_vm.view.DeparturePoint) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.view.DepartureTimeComments) ? _c('div', {
    staticClass: "page-desc dep-comment",
    domProps: {
      "innerHTML": _vm._s(_vm.view.DepartureTimeComments)
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "price-box-wrap"
  }, [_c('div', {
    staticClass: "price-box page-box"
  }, [_c('div', {
    staticClass: "price-label"
  }, [_vm._v("Best Price From")]), _vm._v(" "), _c('div', {
    staticClass: "price-value"
  }, [_vm._v("\n          $" + _vm._s(_vm.discount(_vm.view.Price, 35).discounted) + "\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "lr-btn",
    on: {
      "click": _vm.bookNow
    }
  }, [_vm._v("Book now")])]), _vm._v(" "), (_vm.view.Cancellation_available) ? _c('div', {
    staticClass: "cxl-box page-box"
  }, [_c('div', {
    staticClass: "page-label"
  }, [_vm._v("Cancellation Policy")]), _vm._v(" "), _c('div', {
    staticClass: "cxl-desc"
  }, [_vm._v(_vm._s(_vm.view.Cancellation_Policy))])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c3e72e6a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3e72e6a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DThingsList/details.vue
// module id = 2140
// module chunks = 0